import { useMemo } from 'react';
import { useStorefront } from '@/hooks/useStorefront';

/**
 * Returns the FX rate frozen for the active checkout session.
 *
 * CH fastpath: always returns 1 without any query / lookup. Non-CH
 * storefronts will read the frozen `exchange_rate` from `checkout_sessions`
 * once wired in P2.6. Until then, non-CH is not live (LIVE_STOREFRONTS=['ch']).
 */
export function useSessionExchangeRate(): { rate: number; isReady: boolean } {
  const { storefront } = useStorefront();
  return useMemo(() => {
    if (storefront === 'ch') return { rate: 1, isReady: true };
    return { rate: 1, isReady: true };
  }, [storefront]);
}